<template>
  <div>
    <el-row style="margin-top:20px">
      <download-excel :data="exportData" :fields="json_fields" name="存疑产品表.xls" :before-generate="startDownload"
        :before-finish="endDonload">
        <el-button> 下载存疑产品清单 </el-button>
      </download-excel>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="订单编号" prop="ORDER_CODE" min-width="50"></el-table-column>
          <el-table-column label="提示" prop="MSG" min-width="50"></el-table-column>
          <el-table-column label="产品总数" prop="产品总数" min-width="50"></el-table-column>
          <el-table-column label="自送数量" prop="自送数量" min-width="30"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>

export default {
  created() {
    this.有问题的订单集合 = JSON.parse(sessionStorage.getItem('有问题的订单集合'));
    this.tableData = Object.entries(this.有问题的订单集合).map(([key, value]) => ({
      ORDER_CODE: key,
      产品总数: Number(value.DATA[0]),
      自送数量: Number(value.DATA[1]),
      ...value,
    }));
  },
  data() {
    return {
      json_fields: {
        订单编号: 'ORDER_CODE',
        提示: 'MSG', // 常规字段
        产品总数: '产品总数', // 支持嵌套属性
        自送数量: '自送数量',
      },
      exportData: [],
      tableData: [],
    };
  },

  methods: {
    // 全部订单导出前的数据查询
    async startDownload() {
      this.exportData = this.tableData;
    },
    endDonload() {
      this.exportData = [];
    },
  },
};
</script>
<style scope>
.inline-input {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/thirdPartyTransferErrorProductList_test.vue